import { useEffect, useRef } from 'react'
import { CURRENT_AWARENESS, LEGISLATION } from 'constants/controllers'
import { useSelector } from 'react-redux'
import selectAccordionFoundState from 'redux/selectors/selectAccordionFoundState'
import { scrollTo } from 'libraries/front-end-core/helpers/document'

const useAccordionFound = () => {
  const {
    url, controller, expandedNodeId, breadCrumbClicked, isMobile, actIdMap, pageId, isAccordionLoaded
  } = useSelector(selectAccordionFoundState)
  const scrollToRef = useRef()

  useEffect(() => {
    if ( // if we're not on CA, and not linked to a direct piece of content
      controller === CURRENT_AWARENESS || (expandedNodeId && !breadCrumbClicked)
    ) return

    isAccordionLoaded && scrollTo({ pageId, element: scrollToRef.current, useWindowScrollTo: isMobile })
  }, [controller, expandedNodeId, breadCrumbClicked, scrollToRef, pageId, isMobile, isAccordionLoaded])

  useEffect(() => {
    if (controller === LEGISLATION && actIdMap) {
      const path = url.split('/')
      if (actIdMap.has(path[path.length - 1])) {
        isAccordionLoaded && scrollTo({ pageId, element: scrollToRef.current, useWindowScrollTo: isMobile })
      }
    }
  }, [controller, url, actIdMap, breadCrumbClicked, scrollToRef, pageId, isMobile, isAccordionLoaded])

  return { scrollToRef }
}

export default useAccordionFound
